import React, { Component } from "react";
import { connect } from "react-redux";

import { createNote, fetchNotes } from "../actions";
import FetchButtons from "./FetchButtons";
import NoteForm from "./notes/NoteForm";
import CreateTask from "./tasks/CreateTask";
import User from './User';

class AppHome extends Component {

  componentDidMount(){
    this.props.fetchNotes();
  }

  onSubmit = (formValues) => {
    if (!this.props.isSignedIn) {
      window.gapi.auth2.getAuthInstance().signIn();
    } else {
      this.props.createNote(formValues);
      formValues.note = "";
    }
  };

  render() {
    return (
      <div>
        <User />
        <div className="container-sm my-4">
          <h4>Add your Tasks here</h4>
        </div>
        <CreateTask />
        <NoteForm onSubmit={this.onSubmit}/>
        <FetchButtons />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    isSignedIn: state.auth.isSignedIn,
  };
};


export default connect(mapStateToProps, { createNote, fetchNotes })(AppHome);
